<ng-container id="sizedetector"></ng-container>
